import Vue from 'vue';

const DEFAULTS = {
  TITLE_ERROR: 'Error',
  TITLE_INFO: 'Info',
  TITLE_SUCCESS: 'Success',
  TITLE_WARNING: 'Success',
};

export default class Notifications {
  static error(message, callback = null, title = null) {
    Vue.notify({
      type: 'error',
      group: 'generic',
      title: title || DEFAULTS.TITLE_ERROR,
      text: message,
    });

    if (callback) {
      callback();
    }
  }

  static info (message, title) {
    Vue.notify({
      group: 'generic',
      title: title || DEFAULTS.TITLE_INFO,
      text: message,
    });
  }

  static success (message, title) {
    Vue.notify({
      type: 'success',
      group: 'generic',
      title: title || DEFAULTS.TITLE_SUCCESS,
      text: message,
    });
  }

  static warning (message, title) {
    Vue.notify({
      type: 'warning',
      group: 'generic',
      title: title || DEFAULTS.TITLE_SUCCESS,
      text: message,
    });
  }
};
